import gql from "graphql-tag";

export const GET_TEMPLATE_FEATURES = gql`
  query GetTemplateFeatures($presentationId: ID!, $options: GetManyOptions) {
    getTemplateFeatures(presentationId: $presentationId, options: $options) {
      globalAssets {
        id
        name
        alias
        basePrice
        code
        currency
        desc
        images
        img1
        img2
        isLabel
        isMandatory
        featurePosition
        isSingleAttribute
        isBase
        isVisible
        maxInventory
        costumeAttributes {
          id
          name
          desc
          dynaInventory
          isLabel
          isMandatory
          isDynamic
          isSingleVal
          isVisible
          images
          costumeValues {
            id
            name
            currency
            deadline
            desc
            inventory
            isMandatory
            isLabel
            isVisible
            disclaimer
            topupPrice
            minDownPayment
            position
          }
        }
        isCommon
        section {
          id
          name
        }
      }
    }
  }
`;
